import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const UnitedKingdomFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14779'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14779)'>
				<rect
					width='20'
					height='14'
					fill='#0A17A7'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M-0.915339 -1.34155L7.61976 4.3003V-0.933374H12.3817V4.3003L20.9168 -1.34155L21.9819 0.205985L15.2338 4.66663H20.0007V9.33329H15.2338L21.9819 13.7939L20.9168 15.3415L12.3817 9.69962V14.9333H7.61976V9.69962L-0.915339 15.3415L-1.98047 13.7939L4.76767 9.33329H0.000709891V4.66663H4.76767L-1.98047 0.205984L-0.915339 -1.34155Z'
					fill='white'
				/>
				<path
					d='M13.334 4.43251L22.3807 -1.40002'
					stroke='#DB1F35'
					strokeWidth='0.666667'
					strokeLinecap='round'
				/>
				<path
					d='M14.2949 9.58821L22.4048 14.9452'
					stroke='#DB1F35'
					strokeWidth='0.666667'
					strokeLinecap='round'
				/>
				<path
					d='M5.71906 4.41733L-2.74023 -1.16968'
					stroke='#DB1F35'
					strokeWidth='0.666667'
					strokeLinecap='round'
				/>
				<path
					d='M6.63657 9.52341L-2.74023 15.6173'
					stroke='#DB1F35'
					strokeWidth='0.666667'
					strokeLinecap='round'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 8.4H8.57143V14H11.4286V8.4H20V5.6H11.4286V0H8.57143V5.6H0V8.4Z'
					fill='#E6273E'
				/>
			</g>
		</svg>
	);
};

export default UnitedKingdomFlagIcon;
